import { render, staticRenderFns } from "./MatchExpressions.vue?vue&type=template&id=7bf8ef7f&scoped=true&"
import script from "./MatchExpressions.vue?vue&type=script&lang=js&"
export * from "./MatchExpressions.vue?vue&type=script&lang=js&"
import style0 from "./MatchExpressions.vue?vue&type=style&index=0&id=7bf8ef7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8ef7f",
  null
  
)

export default component.exports